var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{style:({ left: _vm.centerPoint.x, top: _vm.centerPoint.y }),attrs:{"id":"spinner"}},[_c('div',[_vm._l((_vm.balls),function(ball,b){return _c('div',{key:b,staticClass:"ball",style:({
          backgroundColor: _vm.color,
          opacity: ball.opacity,
        }),attrs:{"id":ball.id}})}),(_vm.text)?_c('small',{style:({ color: _vm.color })},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e()],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }